import {
  LISTA_TROCA_FOTO,
  LISTA_TROCA_FOTO_SUCESSO,
  LISTA_TROCA_FOTO_ERRO,
  APROVA_TROCA_FOTO,
  APROVA_TROCA_FOTO_SUCESSO,
  REPROVA_TROCA_FOTO,
  REPROVA_TROCA_FOTO_SUCESSO,
  TROCA_FOTO_ERRO,
} from 'constants/ActionTypes';

const INIT_STATE = {
  carregando: false,
  enviando: false,
  items: [],
  total: 0,
  totalPaginas: 0,
  pagina: 1,
  tamanhoPagina: 20,
  statusFiltro: 'PENDENTE',
  erro: null,
  sucesso: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_TROCA_FOTO:
      return { ...state, carregando: true, erro: null, sucesso: false, statusFiltro: action.payload.status };

    case LISTA_TROCA_FOTO_SUCESSO:
      return {
        ...state,
        carregando: false,
        items: action.payload.items,
        total: action.payload.total,
        totalPaginas: action.payload.totalPaginas || Math.ceil(action.payload.total / action.payload.tamanhoPagina),
        pagina: action.payload.pagina,
        tamanhoPagina: action.payload.tamanhoPagina,
      };

    case LISTA_TROCA_FOTO_ERRO:
      return { ...state, carregando: false, erro: action.payload };

    case APROVA_TROCA_FOTO:
    case REPROVA_TROCA_FOTO:
      return { ...state, enviando: true, erro: null, sucesso: false };

    case APROVA_TROCA_FOTO_SUCESSO:
    case REPROVA_TROCA_FOTO_SUCESSO:
      return { ...state, enviando: false, sucesso: true };

    case TROCA_FOTO_ERRO:
      return { ...state, enviando: false, erro: action.payload };

    default:
      return state;
  }
};
